<div class="form-modal" style="width: 700px">
  <h1 mat-dialog-title>{{ parameters.Title | translate}}</h1>
  <div mat-dialog-content class="px-4">
    <div class="col-sm-12">
      <table id="tableHistory" class="table table-bordered display" cellspacing="0">
        <thead>
          <tr>
            <th></th>
            <th>
              <strong>{{ 'DATE' | translate }}</strong>
            </th>
            <th>
              <strong>{{ 'DOCUMENT' | translate }}</strong>
            </th>
            <th>
              <strong>{{ 'TOTALNETAMOUNT' | translate }}</strong>
            </th>
            <th>
              <strong>{{ 'TOTAL' | translate }}</strong>
            </th>
            <th>
              <strong>{{ 'DONE_BY' | translate }}</strong>
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>

      
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <div class="full-width text-right modal-theme">
        <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
          {{'CLOSE' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>